import { useState, useEffect } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import styled from 'styled-components';
import Stack from 'react-bootstrap/Stack';
import SlideCarousel from '../components/SlideCarousel';
import Ratio from 'react-bootstrap/Ratio';
import { useDispatch } from 'react-redux';
import { setModal, setSubdivision } from '../features/mainStore/mainSlice';
import { useLocation } from 'react-router-dom';

const StyledSection = styled.section`
font-family: 'Roboto';

max-width: 1320px;
margin: 60px auto 0px auto;
padding: 12px 0px;
.header-card {
  color: #ffffff;
}
`

function CanterburyLakeEstatesPage() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [ formValues, setFormValues ] = useState({cs:0});

  useEffect(() => {
    dispatch(setSubdivision('Canterbury Lake Estates'));
    if(!(new URLSearchParams(location.search)).get('frm') && !(new URLSearchParams(location.search)).get('displayForm')) dispatch(setModal('offmarket-community'));    
        var newformValues = {};
    if(localStorage['formData'])
    {
        newformValues = JSON.parse(localStorage['formData']);
        newformValues['cs'] = 0;
    }
    else
    {
        newformValues = {...formValues, cs: 0}
        
    }
    setFormValues(newformValues);   
  },[]) 

  return (
    <>     
    <StyledSection>
      <Container>
      <Row>
        <Col>
          <Card bg='trans-white'>
            <Card.Body>
              <Card.Title><h1 className='blue-color'>About Canterbury Lake Estates and surrounding areas</h1></Card.Title>
              <Card.Subtitle><h2><a href='https://en.wikipedia.org/wiki/Hernando,_Florida' target='_blank' rel='noopener'>Canterbury Lake Estates - Hernando, Florida 34442</a></h2></Card.Subtitle>
              <Card.Text as='div'>
                <p className='indent'>Canterbury Lake Estates is an intimate, lake-centered community within Citrus Hills in Hernando and is one of 14 distinct neighborhoods that make up The Villages of Citrus Hills.</p>
                <Row>
                  <Col xs={12} lg={6} className='py-2'>
                  <Ratio aspectRatio='16x9'>
                    <iframe className='w-100' src='https://www.youtube.com/embed?listType=playlist&list=PLjBxLKqSLoEb3kr0rk89km6AlIytRR1ys&modestbranding=1&autoplay=0&rel=0&fs=0' allowFullScreen allow='autoplay'></iframe>
                    </Ratio>
                  </Col>
                  <Col xs={12} lg={6} className='py-2'>
                    <Stack gap={2} className='align-items-start'>                    
                      <p className='indent'>
                         Designed for privacy and tranquility, this peaceful enclave features a single entrance with no through traffic and centers around three scenic lakes reserved for fishing and non-motorized watercraft. Residents also enjoy direct access to the Rails-to-Trails system, creating an ideal setting for walking, biking, and embracing Florida's natural beauty. The community blends serenity with convenience, offering secure on-site boat and motorhome parking and a prime location near Highway 200 and the Suncoast Parkway for easy access to Ocala and the Tampa area. Please note that some homes include a mandatory social membership to Terra Vista, providing access to select resort-style amenities.
                      </p>
                      <LinkContainer to='/homes-for-sale/Canterbury-Lake-Estates' aria-label='homes for sale in Canterbury Lake Estates - Hernando, Florida 34442' title='homes for sale in Canterbury Lake Estates - Hernando, Florida 34442'>
                        <Button variant='blue'>
                          Canterbury Lake Estates Properties <i role='presentation' className='bi bi-caret-right-fill'></i>
                        </Button>
                      </LinkContainer>  
                        <Button variant='blue' href='/assets/documents/Canterbury-Lake-Estates-Covenants-2001.pdf' aria-label='Canterbury Lake Estates Covenants' title='Canterbury Lake Estates Covenants' target='_blank' rel='noopener'>
                          Canterbury Lake Estates Covenants <i role='presentation' className='bi bi-caret-right-fill'></i>
                        </Button>    
                        <Button variant='blue' href='/assets/documents/Canterbury-Lake-Estates-Deed-Restrictions.pdf' aria-label='Canterbury Lake Estates Deed Restrictions' title='Canterbury Lake Estates Deed Restrictions' target='_blank' rel='noopener'>
                          Canterbury Lake Estates Deed Restrictions <i role='presentation' className='bi bi-caret-right-fill'></i>
                        </Button>          
                        <Button variant='blue' href='/assets/documents/Canterbury-Lake-Estates-BYLAWS-Amended-Restated 9-5-2025_FINAL.pdf' aria-label='Canterbury Lake Estates Bylaws' title='Canterbury Lake Estates Bylaws' target='_blank' rel='noopener'>
                          Canterbury Lake Estates Bylaws <i role='presentation' className='bi bi-caret-right-fill'></i>
                        </Button>                                          
                    </Stack>    
                  </Col>
                </Row>                              
              </Card.Text>              
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col className='py-2'>       
          <SlideCarousel className='featured-carousel' slideType='community' queryValue='Canterbury-Lake-Estates' count={4} controls={false} cardWrapper={true} bg='trans-black' />              
        </Col>
      </Row>
      </Container>
    </StyledSection>
    </>
  );
}

  
  export default CanterburyLakeEstatesPage;